import EnlilAxiosRestAPI from "../../../../util/EnlilAxiosRestAPI";
import EnterpriseComponent from "../../EnterpriseComponent";
import {V1AdminWorkGroupEmployeeIDOCToArray} from "../../../../util/Payload";
import {v4 as uuidv4} from "uuid";

class AdminWorkGroupEmployeeEnterpriseComponent extends EnterpriseComponent {
    performQuery = (page, pageSize, foreignKey) => {
        page = page || 1;
        pageSize = pageSize || this.getDefaultCacheSize();

        this.notifyLoadStartListeners();

        let idocResponse = this.getIDOCResponse() ?? "v1.AdminWorkGroup-002";

        let qbe = btoa(JSON.stringify({
            "ShifamedMessage": {
                "-idoc": idocResponse,
                "-id": uuidv4(),
                "AdminWorkGroup": {
                    "_attributes": {
                        "limit": 1,
                        "sort": null,
                        "offset": 0
                    },
                    "QueryGroups": {
                        "QueryGroup": [
                            {
                                "Name": "QG1",
                                "Type": "QueryGroup",
                                "Operator": "AND",
                                "Membership": {
                                    "Member": [
                                        {
                                            "Type": "Attribute",
                                            "Name": "USID",
                                            "Value": foreignKey,
                                            "Operator": "EQUAL"
                                        }
                                    ]
                                }
                            }
                        ]
                    },
                    "AdminWorkGroupEmployee": {
                        "_attributes": {
                            "limit": pageSize,
                            "sort": this.getFormattedSortSpecification(),
                            "offset": (page - 1) * pageSize
                        }
                    }
                }
            }
        }))

        EnlilAxiosRestAPI({
            method: "GET",
            url: "t3/v1/admin_work_groups",
            json: true,
            params: {
                "QBE": qbe
            },
            headers: {
                "idoc-response": idocResponse,
            },
        }).then(response => {
            this.fetchEnterpriseComponentSuccess(V1AdminWorkGroupEmployeeIDOCToArray(response.data), page, pageSize);
        }).catch(error => {
            this.fetchEnterpriseComponentFailed(error);
        });
    };

    enterpriseComponentPostIDOC = () => {
        let payload = {};

        let AdminWorkGroup = {};

        AdminWorkGroup["USID"] = this.getEnterpriseObject().getEnterpriseComponent("AdminWorkGroup").getAttributeValue("USID");
        AdminWorkGroup["WorkGroupEmployee"] = {
            "USID": this.getAttributeValue("USID")
        }

        payload.ShifamedMessage = {};
        payload.ShifamedMessage["-idoc"] = "v1.AdminWorkGroup-002";
        payload.ShifamedMessage.AdminWorkGroup = AdminWorkGroup;

        return payload;
    };

    performInsert() {
        let payload = this.enterpriseComponentPostIDOC();

        let options = {
            method: "PUT",
            url: "t3/v1/admin_work_groups",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminWorkGroup-002",
                "idoc-response": "v1.AdminWorkGroup-002"
            },
        };
        this.notifyInsertStartListeners();
        EnlilAxiosRestAPI(options)
            .then(response => {
                this.insertEnterpriseComponentSuccess(V1AdminWorkGroupEmployeeIDOCToArray(response.data));
            })
            .catch(error => {
                this.insertEnterpriseComponentFailed(error);
            });
    };

    performDelete() {
        let payload = {
            "ShifamedMessage": {
                "-idoc": "v1.AdminWorkGroup-002",
                "AdminWorkGroup": {
                    "_attributes": {
                        "delete": false
                    },
                    "USID": this.getEnterpriseObject().getEnterpriseComponent("AdminWorkGroup").getAttributeValue("USID"),
                    "WorkGroupEmployee": {
                        "_attributes": {
                            "delete": true
                        },
                        "USID": this.getAttributeValue("USID")
                    }
                }
            }
        }

        let options = {
            method: "DELETE",
            url: "t3/v1/admin_work_groups",
            json: true,
            data: payload,
            headers: {
                "idoc-request": "v1.AdminWorkGroup-002"
            },
        };
        this.notifyDeleteStartListeners();
        EnlilAxiosRestAPI(options)
            .then(() => {
                this.deleteEnterpriseComponentSuccess();
            })
            .catch(error => {
                this.deleteEnterpriseComponentFailed(error);
            });
    };
}

export default AdminWorkGroupEmployeeEnterpriseComponent;